import axios from 'axios'

const changePasswordRoute = '/api/rest/password/change'
const checkPasswordStrengthRoute = '/api/password/strength'

export default {
  async changePassword(oldPassword, newPassword) {
    try {
      const response = await axios.put(changePasswordRoute, {
        oldPassword,
        newPassword,
      })

      return response.data
    } catch (error) {
      throw new Error(error.response.data.errorMessage)
    }
  },

  /** @deprecated use checkPasswordStrength in passwordStrength.api.ts */
  async checkPasswordStrength(password) {
    try {
      const response = await axios.post(checkPasswordStrengthRoute, {
        password,
        type: 'c1password',
      })

      return response.data
    } catch (error) {
      throw new Error(error.response.data.errorMessage)
    }
  },
}
